import { useEffect, useRef } from 'react'
import { PageHeading, StatCardItem, StatCards } from '../../../../../../components'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { SituacaoFaturaBadge } from '../../../faturas-list/components/SituacaoFaturaBadge'
import { useFaturaAtual } from '../../core/useFaturaAtual'
import { useT } from '_metronic/i18n/Metronici18n'

/**
 * Resumo da fatura acima da listagem: descrição como título; instituição, especialidade e
 * unidade como apoio; situação, valor, competência e data em cards; observação abaixo.
 */
export const FaturaAtendimentosInfoHeader = () => {
  const { t } = useT()
  const { fatura, refetch } = useFaturaAtual()
  const { response } = useQueryResponse()

  // Alterar/remover item muda o total da fatura: recarrega o resumo junto com a lista (a 1ª
  // carga da lista é ignorada — a fatura acabou de ser buscada).
  const primeiraCarga = useRef(true)
  useEffect(() => {
    if (!response) return
    if (primeiraCarga.current) {
      primeiraCarga.current = false
      return
    }
    refetch()
  }, [response, refetch])

  const contexto = [
    fatura?.empresa?.nomeFantasia || fatura?.empresa?.nome,
    fatura?.especialidade?.nome,
    fatura?.unidade?.nome,
  ]
    .filter(Boolean)
    .join(' · ')

  const { mesSigla, ano } = fatura?.mesAno ?? {}
  const stats: StatCardItem[] = [
    { label: t('situacao.label'), value: <SituacaoFaturaBadge situacao={fatura?.situacao} /> },
    { label: t('cols.valor_faturar'), value: fatura?.valorTotalFormatado },
    {
      label: `${t('mes.label')}/${t('ano.label')}`,
      value: mesSigla && ano ? `${mesSigla}/${ano}` : undefined,
    },
    { label: t('data.label'), value: fatura?.dataFormatada },
  ]

  return (
    <>
      <PageHeading
        title={fatura ? fatura.descricao || t('fatura.label') : 'Carregando fatura…'}
        description={
          [contexto, fatura?.observacao && `${t('observacao.label')}: ${fatura.observacao}`]
            .filter(Boolean)
            .join(' — ') || undefined
        }
      />
      <StatCards items={stats} ariaLabel='Resumo da fatura' />
    </>
  )
}
